import { BackendClient } from '@/shared/backend/client'

// Initial delay before first poll — indexer won't have the data this soon
const INITIAL_DELAY_MS = 300
const POLL_INTERVAL_MS = 200
const TIMEOUT_MS = 15_000

export async function waitForIndexer(backendClient: BackendClient, digest: string): Promise<void> {
  const deadline = Date.now() + TIMEOUT_MS
  await new Promise(resolve => setTimeout(resolve, INITIAL_DELAY_MS))
  while (Date.now() < deadline) {
    try {
      const indexed = await backendClient.isTransactionIndexed(digest)
      if (indexed) {
        return
      }
    } catch {
      // Network error — continue polling
    }
    await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL_MS))
  }
  // Timeout — proceed anyway (graceful degradation)
}
